import React from 'react';
import { Button } from 'appkit-react';
import { Form } from 'antd';
import { SEGMENTS } from '@model';
// import '/src/styles/common.scss';
import '../../../styles/common.scss';
import TextArea from '@components/TextArea';

export const GlobalEditButton = ({
  selectedMenu,
  actionHandler,
  isLoading,
  isEditing,
  keyContactHandler,
  isShowContacts,
}) => {
  const isInternal = JSON.parse(
    window.localStorage.userInfo || '{}',
  ).isInternal;
  if (selectedMenu === SEGMENTS.gotomarket && isInternal) {
    return !isEditing ? (
      <div className="go-to-market-edit-button role-control">
        <Button
          // size="lg"
          kind="primary"
          onClick={actionHandler}
          isLoading={isLoading}
        >
          Edit
        </Button>
      </div>
    ) : null;
  } else if (selectedMenu === SEGMENTS.keycontact && isInternal) {
    if (isShowContacts) {
      return null;
    }
    return !isEditing ? (
      <Button
        size="lg"
        kind="primary"
        onClick={keyContactHandler}
        isLoading={isLoading}
        className="go-to-market-edit-button role-control"
      >
        Edit
      </Button>
    ) : null;
  }
  return null;
};

export const GlobalEditableCell = (props) => {
  const { isEditing = false, value = '', defaultValue, name } = props;

  return isEditing ? (
    <div>
      <Form.Item
        name={name}
        className={isEditing ? '' : 'hide'}
        initialValue={defaultValue}
      >
        <TextArea
          type="text"
          className="go-to-market-editable-input"
          max
          autoSize={{ minRows: 2, maxRows: 16 }}
        />
      </Form.Item>
    </div>
  ) : (
    <div className="textInoneLine">{value}</div>
  );
};
export const SaveCancelButtons = ({
  form,
  selectedMenu,
  cancelHandler,
  isLoading,
  isEditing,
}) => {
  if (
    selectedMenu === SEGMENTS.gotomarket ||
    selectedMenu === SEGMENTS.keycontact
  ) {
    return isEditing ? (
      <div className="go-to-market-bottom-buttons">
        <Button
          className="go-to-market-cancel"
          kind="secondary"
          size="lg"
          onMouseDown={cancelHandler}
          isLoading={isLoading}
        >
          Cancel
        </Button>
        <Button
          className="go-to-market-save"
          kind="primary"
          size="lg"
          isLoading={isLoading}
          onMouseDown={() => {
            form.submit();
          }}
        >
          Save
        </Button>
      </div>
    ) : null;
  }
  return null;
};
